import { ContactPhone } from 'src/components/PhoneInput/PhoneInput';
import { Address } from './Address';

export interface User {
  userId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  contactPreference: unknown;
  username: string;
  residencyCountryCode: string;
  nationalityCountryCode: string[];
  userType: UserType;
  companyName: string;
  companyId: number;
  staffId: number;
  beneId: number;
  avatar: string;
  jobTitle: string;
  officeLocation: string;
  isSSO: boolean;
  passwordExpired: boolean;
  agreementAccepted: boolean;
  customRoles: unknown[];
  preferredName: string;
  linkedUsers: LinkedUser[];
  isShadowUser: boolean;
  dateFormat: string;
  hasCCM: boolean;
  userSettings: UserSettings;
  isMFAEnabled: boolean;
  isUserParentMFAEnabled: boolean;
  hasMFARegisteredDevice: boolean;
  deviceRegistrationDate: unknown;
  isActive: boolean;
  loginMethodType: string;
  beneficiaryNumber: string;
}

export interface UserType {
  types: string[];
  role: string;
}

export interface LinkedUser {
  userId: number;
  userType: string;
}

export interface UserSettings {
  dateFormat: string;
  caseListView: string;
  taskListView: string;
  profileCaseListView: string;
  reportNoteListView: string;
  immigrationDocumentView: string;
  caseListView_MappedUXValue: boolean;
  taskListView_MappedUXValue: string;
  profileCaseListView_MappedUXValue: boolean;
  reportNoteListView_MappedUXValue: boolean;
  immigrationDocumentView_MappedUXValue: boolean;
  advanceTaskView: boolean;
  dueThroughValue: number;
  dueThroughPeriod: string;
  itemsPerPage: number;
  tasksHomePage: TasksHomePage;
  billingPage: BillingPage;
}

export interface TasksHomePage {
  columnsSettings: unknown[];
}

export interface BillingPage {
  columnsSettings: unknown[];
}

export interface ContactEmail {
  emailId: number | undefined;
  emailAddress: string;
  isPrimary: boolean;
  isValid?: boolean;
}

export interface UserContact {
  contactRefId: number;
  contactAddresses: ContactAddress[];
  contactEmails: ContactEmail[];
  contactPhones: ContactPhone[];
}

export enum AddressType {
  MAILING_ADDRESS = 'MAILING_ADDRESS',
  CURRENT_RESIDENCE = 'CURRENT_RESIDENCE',
  PERMANENT_RESIDENCE = 'PERMANENT_RESIDENCE',
  WORK = 'WORK',
  EMPTY = '',
}

export type ContactAddress = Address & {
  contactAddressId?: number;
  addressType?: AddressType;
  workLocationType?: string;
  clientName?: string;
  unitType?: string;
  startDate?: string;
  endDate?: string;
  createdDate?: string;
};

export interface ChangePasswordInput {
  oldPassword: string;
  newPassword: string;
}

export interface IEducationHistory {
  beneId?: number;
  countryCode?: string;
  degreeReceived?: string;
  eduHistoryId?: number;
  fieldOfStudy?: string;
  institution?: string;
  isArchive?: boolean;
}

export interface IDeviceRegistration {
  userId?: number;
  updatedDate?: string;
  updatedDateOnly?: string;
}

export interface I94BannerStatus {
  dismissedDate: string | null;
  showBanner: boolean;
}
